import { SinglePropertyContainer, LeftDetails, RightDetails } from './OfferDetailsSinglePropertySkeletonLoader.styles';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const OfferDetailsSinglePropertySkeletonLoader: React.FC<any> = () => {
  return (
    <SinglePropertyContainer>
      <div className="container spo-wrapper">
        <LeftDetails>
          <div className="skeleton-loader offer-description"></div>
          <div className="skeleton-loader offer-description"></div>
          <div className="skeleton-loader sub-heading"></div>
          <div className="skeleton-loader offer-description"></div>
          <div className="skeleton-loader offer-description"></div>
          <div className="skeleton-loader offer-description"></div>
          <div className="skeleton-loader offer-description"></div>
          <div className="skeleton-loader sub-heading"></div>
          <div className="skeleton-loader offer-description"></div>
          <div className="skeleton-loader terms-and-conditions"></div>
        </LeftDetails>
        <RightDetails>
          <div className="skeleton-loader sub-heading"></div>
          <div className="skeleton-loader offer-description"></div>
          <div className="skeleton-loader offer-description"></div>
          <div className="skeleton-loader offer-description"></div>
          <div className="skeleton-loader offer-description"></div>
        </RightDetails>
      </div>
    </SinglePropertyContainer>
  );
};
